import { defineStore, storeToRefs } from "pinia";
import { computed } from "vue";
import { useBidderTargetsStore } from "@stores/bidderTargets";

export const useBudgetStore = defineStore("budget", () => {
  const bidderTargetsStore = useBidderTargetsStore();
  const { bidderStatus } = storeToRefs(bidderTargetsStore);

  const bidderFail = computed(() => {
    return bidderStatus && bidderStatus.value?.status
      ? ["S6_without_budget_change", "UNKNOWN_ERROR", "FETCHER_ERROR", "FAILURE"].includes(bidderStatus?.value.status)
      : " --";
  });

  return {
    bidderFail,
  };
});
